<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
  </div>
</template>

<script>
export default {
  mounted() {
    // 監聽視窗大小變化
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.$store.commit("system/setScreenWidth", window.screenWidth);
      })();
    };
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";

/* Import Font Awesome Icons Set */
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~font-awesome-animation/dist/font-awesome-animation.min.css";

/* Import Weather Icons Set */
@import "~weather-icons2/css/weather-icons.min.css";
@import "~weather-icons2/css/weather-icons-wind.min.css";
</style>
